import { later } from '@ember/runloop';
import { service } from '@ember/service';

import $ from 'jquery';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPreviewPopupEditTour extends TourBase {
	@service('tour') declare tourService: Service.Tour;

	static keyForPersistantDone = UserSettingsKey.REPORTS_PREVIEW_POPUP_EDIT;

	get id(): string {
		return TourId.REPORTS__PREVIEW_POPUP_EDIT;
	}

	override get keyForPersistantDone(): string {
		return ReportsPreviewPopupEditTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					return $('.popup-type-board-preview .title .actions-right .edit');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override end(): void {
		super.end();

		later(() => {
			this.tourService.initTour(TourId.REPORTS__PREVIEW_POPUP_SHARE)?.start();
		}, 2000);
	}
}
